import { browser } from '$app/environment';
import { writable } from 'svelte/store';
const COOKIE_CONSENT_KEY = 'cookie_consent';
const COOKIE_CONSENT_EXPIRY_DAYS = 365;
function getCookieConsent() {
    if (!browser)
        return false;
    try {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (consent === null)
            return false;
        const parsed = JSON.parse(consent);
        const now = new Date().getTime();
        if (parsed.expiry && now > parsed.expiry) {
            localStorage.removeItem(COOKIE_CONSENT_KEY);
            return false;
        }
        return parsed.value === true;
    }
    catch (e) {
        console.warn('Error reading cookie consent:', e);
        return false;
    }
}
function createCookieConsentStore() {
    const { subscribe, set } = writable(getCookieConsent());
    return {
        subscribe,
        set: (value) => {
            if (browser) {
                try {
                    const expiry = new Date();
                    expiry.setDate(expiry.getDate() + COOKIE_CONSENT_EXPIRY_DAYS);
                    const data = {
                        value,
                        expiry: expiry.getTime(),
                        timestamp: new Date().getTime()
                    };
                    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(data));
                    set(value);
                }
                catch (e) {
                    console.warn('Error saving cookie consent:', e);
                }
            }
        },
        clear: () => {
            if (browser) {
                try {
                    localStorage.removeItem(COOKIE_CONSENT_KEY);
                    set(false);
                }
                catch (e) {
                    console.warn('Error clearing cookie consent:', e);
                }
            }
        }
    };
}
export const cookieConsent = createCookieConsentStore();
export function setCookieConsent(value) {
    cookieConsent.set(value);
}
export function clearCookieConsent() {
    cookieConsent.clear();
}
export function hasCookieConsent() {
    return getCookieConsent();
}
